'use client'

import { 
  ThemeProvider, 
  SectionThemeProvider, 
  LoadingProvider, 
  ModalProvider,
  MouseProvider,
  Cursor,
  UserMetaProvider
} from '@caffeina-siad/ui-kit'

const Template = ({ children }: { children: React.ReactNode }) => {  
  return (
    <>
      <ThemeProvider>
        <LoadingProvider>
          <ModalProvider>
            <SectionThemeProvider>
              <UserMetaProvider>
                <MouseProvider>
                  {children}
                  <Cursor />
                </MouseProvider>
              </UserMetaProvider>
            </SectionThemeProvider>
          </ModalProvider>
        </LoadingProvider>
      </ThemeProvider>
    </>
  )
}

export default Template
